import React from 'react';

const ProductCardSkeleton = () => {
  return (
    <div className="w-full bg-white rounded-xl shadow-sm border border-gray-100 overflow-hidden flex flex-col animate-pulse">
      {/* Image Section */}
      <div className="relative overflow-hidden">
        {/* Tag Skeleton */}
        <div className="absolute top-3 left-3 z-10">
          <div className="h-5 w-14 sm:w-16 bg-gray-200 rounded-full"></div>
        </div>

        {/* Wishlist Button Skeleton */}
        <div className="absolute top-2 right-2 z-10">
          <div className="h-6 w-6 sm:h-7 sm:w-7 rounded-full bg-gray-200"></div>
        </div>

        {/* Product Image Skeleton - Responsive aspect square */}
        <div className="w-full h-0 pb-[100%] relative bg-gray-200">
          {/* Empty div for aspect ratio */}
        </div>
      </div>

      {/* Product Info */}
      <div className="p-3 flex flex-col flex-grow">
        {/* Product Name Skeleton - Two lines responsive */}
        <div className="h-3.5 sm:h-4 bg-gray-200 rounded mb-1.5 w-full"></div>
        <div className="h-3 sm:h-3.5 bg-gray-200 rounded w-3/4"></div>

        {/* Rating Skeleton - Responsive spacing */}
        <div className="flex items-center gap-1 mt-1.5 sm:mt-0.5">
          <div className="flex items-center gap-[1px] sm:gap-[2px]">
            {[...Array(5)].map((_, index) => (
              <div 
                key={index} 
                className="w-2.5 h-2.5 sm:w-3 sm:h-3 bg-gray-200 rounded-sm"
              ></div>
            ))}
          </div>
          
          {/* Rating text skeleton */}
          <div className="h-2 w-6 sm:h-2.5 sm:w-8 bg-gray-200 rounded ml-0.5 sm:ml-1"></div>
          
          {/* Reviews count skeleton */}
          <div className="h-2 w-10 sm:h-2.5 sm:w-12 bg-gray-200 rounded"></div>
        </div>

        {/* Price and Return Policy Skeleton */}
        <div className="mt-auto">
          {/* Price skeleton - Responsive */}
          <div className="flex items-center gap-2 sm:gap-3 mt-2">
            <div className="h-5 sm:h-6 w-16 sm:w-20 bg-gray-200 rounded"></div>
            <div className="h-3.5 sm:h-4 w-12 sm:w-16 bg-gray-200 rounded"></div>
          </div>
          
          {/* Return policy skeleton */}
          <div className="flex items-center gap-1 mt-1 sm:mt-1">
            <div className="h-2.5 w-2.5 sm:h-3 sm:w-3 bg-gray-200 rounded-full"></div>
            <div className="h-2.5 w-28 sm:h-3 sm:w-32 bg-gray-200 rounded"></div>
          </div>
        </div>
      </div>

      {/* Button Skeleton - Responsive padding and height */}
      <div className="px-3 pb-3">
        <div className="w-full h-8 sm:h-9 bg-gray-200 rounded-lg"></div>
      </div>
    </div>
  );
};

export default ProductCardSkeleton;